export default __webpack_public_path__ + "static/media/landscape10.4a57f4c6.jpeg";